module.exports = __webpack_public_path__ + "static/media/goat.04a73f73.jpg";